export default __webpack_public_path__ + "static/media/moment-btn.abb4a1c6.png";